import React, { createContext, useState, useEffect } from "react";

const OrderContext = createContext();

const OrderListStore = (props) => {
  const [placedData, setPlacedData] = useState({
    data: [],
    page: 0,
    hasMore: false,
  });

  const [approvedData, setApprovedData] = useState({
    data: [],
    page: 0,
    hasMore: false,
  });
  const [shippedData, setShippedData] = useState({
    data: [],
    page: 0,
    hasMore: false,
  });
  const [rejectedData, setRejectedData] = useState({
    data: [],
    page: 0,
    hasMore: false,
  });
  const [archiveData, setArchiveData] = useState({
    data: [],
    page: 0,
    hasMore: false,
  });
  const [orderDetails, setOrderDetails] = useState({});

  const [buyerSelected, setBuyerSelected] = useState("");

  return (
    <OrderContext.Provider
      value={{
        placedData,
        setPlacedData,
        orderDetails,
        setOrderDetails,
        approvedData,
        setApprovedData,
        shippedData,
        setShippedData,
        rejectedData,
        setRejectedData,
        archiveData,
        setArchiveData,
        buyerSelected,
        setBuyerSelected,
      }}
    >
      {props.children}
    </OrderContext.Provider>
  );
};

export { OrderListStore, OrderContext };
